export default { // ui related stuff
  namespaced: true,
  state: {
    drawer: window.innerWidth > 1264,
    bitrixLoginModal: false,
    loginModal: false,
    registerModal: false,
  },
  mutations: {
    // drawer
    toggleDrawer: (state) => { state.drawer = !state.drawer },
    setDrawer: (state, { value }) => { state.drawer = !!value },
    // loginModal
    setBitrixLoginModal: (state, { value }) => { state.bitrixLoginModal = !!value },
    setLoginModal: (state, { value }) => { state.loginModal = !!value },
    setRegisterModal: (state, { value }) => { state.registerModal = !!value },
  },
}
